import { Briefcase, Handshake } from 'lucide-react';
import { StatusChip } from '@/components/admin/ui';
import { cn } from '@/lib/utils';
import { tenantEnquiryTypeShortLabel } from '@/lib/enquiry-types';

/**
 * "What's it about?" chip for Contact page messages. Job applications and
 * partnership approaches get their own icon and colour so they don't read as
 * sales leads. Renders nothing for messages without a type.
 */
export function EnquiryTypeChip({ type, className }: { type: string | null | undefined; className?: string }) {
  const label = tenantEnquiryTypeShortLabel(type);
  if (!label) return null;
  const Icon = type === 'recruitment' ? Briefcase : type === 'partner' ? Handshake : null;
  return (
    <StatusChip
      tone={Icon ? 'grey' : 'violet'}
      dot={false}
      className={cn('gap-1 whitespace-nowrap', className)}
      title={Icon ? 'Not a sales lead: kept out of your conversion numbers' : 'What the enquiry is about'}
      data-testid="enquiry-type-chip"
    >
      {Icon && <Icon className="h-3 w-3" aria-hidden="true" />}
      {label}
      {Icon && <span className="sr-only"> (not a sales lead)</span>}
    </StatusChip>
  );
}
